import request from '@/utils/request';

// 定义通用响应类型
interface ApiResponse<T = any> {
  code: number;
  msg: string;
  data: T;
}

// 发送消息
export function sendUserMessage(data: { toUserId: number; content: string }): Promise<ApiResponse> {
  return request({
    url: '/user/message/send',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  });
}

// 分页查询聊天记录
export function getUserMessagePage(data: { 
  page: number; 
  pageSize: number; 
  targetUserId: number 
}): Promise<ApiResponse<{ total: number; records: any[] }>> {
  return request({
    url: '/user/message/page',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  });
}

// 标记消息已读
export function markMessageAsRead(messageId: number): Promise<ApiResponse> {
  return request({
    url: `/user/message/read/${messageId}`,
    method: 'put'
  });
}

// 批量标记已读
export function batchMarkMessageAsRead(messageIds: number[]): Promise<ApiResponse> {
  return request({
    url: '/user/message/read/batch',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: messageIds
  });
}

// 查询未读消息数
export function getUnreadMessageCount(): Promise<ApiResponse<number>> {
  return request({
    url: '/user/message/unread/count',
    method: 'get'
  });
}

// 点赞评论
export function likeComment(commentId: number): Promise<ApiResponse> {
  return request({
    url: `/user/interaction/likeComment/${commentId}`,
    method: 'put'
  });
}